import { render, staticRenderFns } from "./form-info.vue?vue&type=template&id=c715c9f6&scoped=true&"
import script from "./form-info.vue?vue&type=script&lang=js&"
export * from "./form-info.vue?vue&type=script&lang=js&"
import style0 from "./form-info.vue?vue&type=style&index=0&id=c715c9f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c715c9f6",
  null
  
)

export default component.exports